export const METRIC_COLORS_V2 = 'metricColorsV2';
export const COLOR_SINGLE_EXPERIMENT_KEY = 'singleExperiment';
